import React from 'react';
import { Link } from 'react-router-dom';
import { formatDate } from '../../data/constants';

const ArticleCard = ({ title, date, image, category, slug }) => (
    <Link to={`/articleDetail/${slug}`} className="articleCard">
        <div className="articleCardImage">
            <img src={image} alt={title} />
            {category && <span className="articleCardCategory">{category}</span>}
        </div>
        <div className="articleCardContent">
            <h3 className="articleCardTitle">{title}</h3>
            <span className="articleCardDate">{formatDate(date)}</span>
        </div>
    </Link>
);

export default ArticleCard;